module.exports = __webpack_public_path__ + "Roboto-Light.7b5fb88f12bec8143f00.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-Light.ttf
// module id = 384
// module chunks = 2